import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './EditPosting.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { clearOpportunity, getOpportunityById, postPutOpportunity, setOpportunity } from "containers/Opportunities/store/actions";
import { getAllIndustryExperienceTypes, getAllLocations, getAllSkills, getAllSpecialties } from 'containers/App/store/actions';

import EditPostingForm from './EditPostingForm';
import H1 from 'components/H1';
import Modal from 'components/Modal';
import PageContent from 'components/PageContent';
import ModalButtons from "../../../components/ModalButtons";
import Button from "../../../components/Button";

class EditPosting extends React.Component {
    constructor() {
        super();

        this.state = {
            showErrorModal: false,
            showSuccessModal: false
        };
    }
    componentWillMount() {
        document.body.classList.add('edit-posting-page');
        document.body.classList.add('fixed-buttons');

        this.props.getAllIndustryExperienceTypes();
        this.props.getAllLocations();
        this.props.getAllSkills();
        this.props.getAllSpecialties();

        if(this.props.params.id != null) {
            this.props.getOpportunityById(this.props.params.id)
                .then((res) => {
                    console.log(res);
                });
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('edit-posting-page');
        document.body.classList.remove('fixed-buttons');
        this.props.clearOpportunity();
    }

    handleCancel() {
        this.props.clearOpportunity();
        this.props.changeLocation('/postings');
    }

    handleSubmit(isValid, published) {
        if(isValid === true) {
            let newPostingObj = update(this.props.opportunities.opportunity, {
                published: {$set: published}
            });
            this.props.setOpportunity(newPostingObj);

            this.props.postPutOpportunity()
                .then((res) => {
                    this.setState({showSuccessModal: true});
                    this.props.changeLocation(`/posting/${res.data.data.id}`);
                })
                .catch((err) => {
                    this.setState({showErrorModal: true});
                })
        }
    }

    render() {
        return (
            <PageContent className="edit-posting">
                <H1>
                    {this.props.params.id == null ? 'Create a New Job Posting' : 'Edit Job Posting'}
                </H1>

                <EditPostingForm
                    error={this.props.opportunities.error}
                    handleCancel={this.handleCancel.bind(this)}
                    industryExperienceTypes={this.props.app.industryExperienceTypes}
                    isSaving={this.props.opportunities.isSaving}
                    onInvalid={this.handleSubmit.bind(this, false, true)}
                    onValid={this.handleSubmit.bind(this, true, true)}
                    onInvalidDraft={this.handleSubmit.bind(this, false, false)}
                    onValidDraft={this.handleSubmit.bind(this, true, false)}
                    opportunity={this.props.opportunities.opportunity}
                    setOpportunity={this.props.setOpportunity.bind(this)}
                    specialties={this.props.app.specialties}
                />

                <Modal closeModal={() => {
                    this.setState({showSuccessModal: false});
                    window.scrollTo(0, 0);
                }}
                       show={this.state.showSuccessModal === true}
                       title="Job Posting Saved Successfully">
                    <ModalButtons buttonCount={1}>
                        <Button onClick={() => this.setState({showSuccessModal: false})}>
                            OK
                        </Button>
                    </ModalButtons>
                </Modal>

                <Modal closeModal={() => this.setState({showErrorModal: false})}
                       show={this.state.showErrorModal === true}
                       title="There was an error saving your posting">
                    <div>
                        {this.props.opportunities.error.friendlyMessage || this.props.opportunities.error.message}
                    </div>
                    <ModalButtons buttonCount={1}>
                        <Button onClick={() => this.setState({showErrorModal: false})}>
                            OK
                        </Button>
                    </ModalButtons>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        opportunities: state.opportunities
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearOpportunity: () => dispatch(clearOpportunity()),
        getAllIndustryExperienceTypes: () => dispatch(getAllIndustryExperienceTypes()),
        getAllLocations: () => dispatch(getAllLocations()),
        getAllSkills: () => dispatch(getAllSkills()),
        getAllSpecialties: () => dispatch(getAllSpecialties()),
        getOpportunityById: (opportunityId) => dispatch(getOpportunityById(opportunityId)),
        postPutOpportunity: () => dispatch(postPutOpportunity()),
        setOpportunity: (opportunityObj) => dispatch(setOpportunity(opportunityObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPosting);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/EditPosting/index.js